import React, { Fragment } from "react";
import { Table, Button } from "antd";
import moment from "moment";
import { apiRefresh } from "../../services/api";
import { saveAs } from "file-saver";

const columns = [
  {
    title: "EZM ID",
    dataIndex: "ezmid",
    key: "ezmid",
  },
  {
    title: "CLIENT",
    dataIndex: "clientName",
    key: "clientName",
  },
  {
    title: "EMAIL",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "FILE NOTES",
    dataIndex: "fileNote",
    key: "fileNote",
    render: (text, row, index) => {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
      );
    },
  },
  {
    title: "USERS",
    dataIndex: "fullName",
    key: "fullName",
  },
  {
    title: "CREATED DATE",
    dataIndex: "createdDate",
    key: "createdDate",
    render: (text) => <span>{moment(text).format("DD/MM/YYYY")}</span>,
  },
];
// const SaleHistoryTable = ({ SaleHistoryReport, displayText }) => {
export class FileNotesTable extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1,
      pageSize: 20,
      totalPages: props.reportsCount,
      defaultCurrent: 1,
    };
  }

  paginate = (value) => {
    this.setState(
      { pageSize: value.pageSize, pageNumber: value.current },
      () => {
        let data = {
          processingPerson: this.props.requestData.processingIds,
          dateFrom:
            this.props.requestData.dateFrom || "1900-01-01T00:00:00.000Z",
          dateTo: this.props.requestData.dateTo || "1900-01-01T00:00:00.000Z",
          pageSize: this.state.pageSize,
          pageNumber: this.state.pageNumber,
        };
        this.props.onFileNotesReport(data).then(() => {
          this.setState(
            {
              defaultCurrent: 1,
              //   branchId: this.state.branchId,
            },
            () => {
              console.log("state", this.state);
            }
          );
        });
      }
    );
  };

  clientEmployerExport = () => {
    let data = {
      processingPerson:
        this.props.requestData.processingIds ||
        "00000000-0000-0000-0000-000000000000",
      dateFrom: this.props.requestData.dateFrom || "1900-01-01T00:00:00.000Z",
      dateTo: this.props.requestData.dateTo || "1900-01-01T00:00:00.000Z",
    };
    this.setState({ loading: true });
    const visaExpiryOpt = {
      url: `v1/client/filenote/FileNotespdfAllPdf`,
    };
    visaExpiryOpt.types = [
      "SERVICE_AGREEMENT_REPORT_EXPORT_SUCCESS",
      "SERVICE_AGREEMENT_REPORT_EXPORT_FAILURE",
    ];

    apiRefresh
      .postWithFileRes(visaExpiryOpt, data)
      .then((res) => {
        this.setState({ loading: false });
        var blob = new Blob([res], {
          type: "application/octet-stream",
        });
        saveAs(blob, "File_Notes_Report.pdf");
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { fileNotesReportRes, displayText } = this.props;
    return (
      <Fragment>
        <div className="report-table">
          <div className="rep-print-row-cont">
            <div
              className="pciq-top-div"
              style={{ marginBottom: 5, marginLeft: 10 }}
            >
              <span
                className="pc-top-div-text"
                style={{ color: "#0A3C5D", fontSize: 12 }}
              >
                {displayText}
              </span>
            </div>
            <Button
              className="button-blue"
              style={{ marginTop: 10 }}
              onClick={this.clientEmployerExport}
              loading={this.state.loading}
            >
              Export
            </Button>
          </div>
          <Table
            columns={columns}
            dataSource={fileNotesReportRes && fileNotesReportRes}
            className="border-3 table-head"
            bordered
            onChange={this.paginate}
            pagination={{
              defaultCurrent: this.state.defaultCurrent,
              total: this.props.reportsCount,
              defaultPageSize: 20,
              showSizeChanger: true,
              pageSizeOptions: ["20", "50", "100", "150", "200"],
            }}
            scroll={{ x: "auto" }}
          />
        </div>
      </Fragment>
    );
  }
}
export default FileNotesTable;
